<template>
  <div>
    <b-card>
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form @submit.stop.prevent="onSubmit">
        <div
          v-for="metadatas_item in metadatas"
          :key="metadatas_item.id"
        >
       <b-row>
         <b-col> <div class="content-ch" >
                <b-form-checkbox
                  :id="'telegram_' + metadatas_item.id"
                  v-model="metadatas_item.is_active"
                  value="1"
                >
                <span>{{metadatas_item.title}}</span>
                </b-form-checkbox>
              </div></b-col>

       </b-row>
          <hr />
        </div>

        <br />
        <b-button type="submit" class="mr-3" variant="success">ثبت</b-button>
        <b-button class="mr-3" variant="danger" href="#/dashboard"
          >بازگشت</b-button
        >
      </b-form>
    </b-card>
  </div>
</template>
<style>
.content-ch {
  margin-top: 10px;
  display: inline-block;
}
</style>
<script>
import sessionHelper from "../../helpers/sessionHelper";
import httpHelper from "../../helpers/httpHelper";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
export default {
  name: "activeGateway",
  data: function () {
    return {
      metadatas: null,
      errors: [],
    };
  },
  components: {},
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "درگاه فعال" }]);
    this.filterData();
  },
  methods: {
    onSubmit() {
      var data = { metadatas:this.metadatas};
      httpHelper.postData("metadataupdate", data).then((response) => {
        if (response.success) {
          this.$router.push("/dashboard");
        } else {
          this.errors = [];
           for (var key in response.error) {
              response.error[key].forEach(element => {
                this.errors.push(element);
              });
            }
          
        }
      });
    },
    filterData: function () {
      httpHelper.setAuth();

      httpHelper.getData("metadata?metadata_group_id=115").then((res) => {
        this.metadatas = res.result;
      });
    },
  },
};
</script>
